import styled from 'styled-components'
import theme from 'styles/theme'
import { getBGColor, getBtnMainColor } from 'utils/themeUtils'

export const CarouselCounter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  display: block;
  overflow: visible;
  padding: 0 ${theme.space[3]};
`

export const CarouselCounterWrapper = styled.div`
  max-width: ${theme.containterMaxWidth};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  width: 100%;
  margin: 0 auto;

  html[dir='rtl'] & {
    justify-content: flex-end;
    right: 30px;

    ${theme.mediaQueries.large} {
      right: 60px;
    }
  }
`

export const CarouselCounterContainer = styled.div`
  display: block;
  position: relative;
  width: 40px;
  height: 40px;
  background: ${getBGColor()};
  border-radius: 50%;
  transform: translate3d(0, 30px, 0);

  ${theme.mediaQueries.large} {
    transform: translate3d(0, 60px, 0);
  }

  :before {
    content: '';
    position: absolute;
    display: block;
    width: calc(100% / 3);
    height: 1px;
    top: calc(50% - 1px);
    left: calc(100% / 3);
    transform: rotate(315deg);
    background: ${getBtnMainColor()};

    html[dir='rtl'] & {
      transform: rotate(45deg);
    }
  }

  > p {
    position: absolute;
    display: block;
    width: 50%;
    height: 50%;
    text-align: center;
    vertical-align: middle;
    line-height: 20px;
    padding: 0;
    margin: 0;
    color: ${getBtnMainColor()};
  }

  > p:nth-child(1) {
    top: 4px;
    left: 4px;

    html[dir='rtl'] & {
      left: auto;
      right: 4px;
    }
  }

  > p:nth-child(2) {
    bottom: 4px;
    right: 4px;

    html[dir='rtl'] & {
      right: auto;
      left: 4px;
    }
  }
`
